import React, { useState, useEffect } from 'react';
import LoginForm from '../components/auth/LoginForm';
import SignupForm from '../components/auth/SignupForm';
import ForgotPasswordForm from '../components/auth/ForgotPasswordForm';
import { useAuth } from '../contexts/AuthContext';
import { useNavigate } from 'react-router-dom';

const AuthPage = () => {
  const [isLogin, setIsLogin] = useState(true);
  const [showForgotPassword, setShowForgotPassword] = useState(false);
  const [showMFA, setShowMFA] = useState(false);
  const [cognitoUser, setCognitoUser] = useState(null);
  const { login, signup, loading, error } = useAuth();
  const navigate = useNavigate();



  const handleLogin = async (credentials) => {
    if (credentials.mfaCode && cognitoUser) {
      try {
        const result = await login({ ...credentials, cognitoUser });
        if (result && !result.requiresMFA) {
          navigate('/');
        }
        return result;
      } catch (error) {
        return;
      }
    }
    
    try {
      const result = await login(credentials);
      
      if (result?.requiresMFA && !credentials.mfaCode) {
        setTimeout(() => {
          setShowMFA(true);
          setCognitoUser(result.cognitoUser);
        }, 0);
        return result;
      }
      
      if (result && !result.requiresMFA) {
        navigate('/');
      }
      
      return result;
    } catch (error) {
      // Error handling
    }
  };





  const handleSignup = (userData) => {
    return signup(userData)
      .then(result => {
        if (userData.isVerification) {
          setIsLogin(true);
          return result;
        }
        
        if (result?.needsVerification) {
          return result;
        }
        
        return result;
      })
      .catch(error => {
        return { error: error.message };
      });
  };

  const switchToSignup = () => {
    setIsLogin(false);
  };

  const switchToLogin = () => {
    setIsLogin(true);
    setShowForgotPassword(false);
    setShowMFA(false);
    setCognitoUser(null);
  };

  const handleForgotPassword = () => {
    setShowForgotPassword(true);
  };

  return (
    <>
      {showForgotPassword ? (
        <ForgotPasswordForm onBackToLogin={switchToLogin} />
      ) : isLogin ? (
        <LoginForm
          onSwitchToSignup={switchToSignup}
          onForgotPassword={handleForgotPassword}
        />
      ) : (
        <SignupForm 
          onSwitchToLogin={switchToLogin} 
          onForgotPassword={handleForgotPassword}
        />
      )}
    </>
  );
};

export default AuthPage;